import React, { useEffect, useState } from 'react';
import API from '../services/api';
import Button from '../ui/Button';
import LinkStatusList, { fmtName } from '../components/LinkStatusList';

const PAGE_SIZE = 20;

export default function TherapistSentLinksPage() {
  const [links, setLinks] = useState([]);
  const [statusFilter, setStatusFilter] = useState('all');
  const [search, setSearch] = useState('');
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  useEffect(() => {
    API.get('/therapist/sent-links')
      .then((res) => setLinks(res.data || []))
      .catch(() => setLinks([]));
  }, []);

  const visible = links.filter((l) => {
    if (statusFilter !== 'all' && l.status !== statusFilter) return false;
    if (search && !fmtName(l.clientName).toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });
  const shown = visible.slice(0, visibleCount);

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Sent Links</h2>
      <p style={{ color: 'var(--text-muted)', marginTop: 0 }}>
        Status of links you've sent your clients — welcome/intake forms and Release of Information requests.
      </p>

      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center', margin: '1rem 0' }}>
        <select value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setVisibleCount(PAGE_SIZE); }}>
          <option value="all">All statuses</option>
          <option value="pending">Pending</option>
          <option value="completed">Completed</option>
          <option value="expired">Expired</option>
        </select>
        <input type="text" placeholder="Search client…" value={search} onChange={(e) => { setSearch(e.target.value); setVisibleCount(PAGE_SIZE); }} />
      </div>

      {visible.length === 0 ? (
        <p>No links found.</p>
      ) : (
        <>
          <LinkStatusList rows={shown} />
          <div style={{ marginTop: 12, color: 'var(--text-muted)', fontSize: 13 }}>
            Showing {shown.length} of {visible.length}
            {visible.length > visibleCount && (
              <Button variant="subtle" style={{ marginLeft: 12 }} onClick={() => setVisibleCount((c) => c + PAGE_SIZE)}>
                Show more
              </Button>
            )}
          </div>
        </>
      )}
    </div>
  );
}
